module.exports = __webpack_public_path__ + "assets/img/isresave.6940e83b.png";